import getObjectsMatchPropVal from "../getObjectsMatchPropVal"
import values from 'mout/object/values'

export default function filterGroupData(groupData, selection, groupType) {
  if (groupType === 'Class') {
    if (selection.Teacher) {
      return getObjectsMatchPropVal(groupData, 'teacher', selection.Teacher)
    } else {
      return []
    }
  } else if (groupType === 'Teacher') {
    if (selection.School) {
      return getObjectsMatchPropVal(groupData, 'school', selection.School, 'Teacher')
    } else {
      return []
    }
  } else if (groupType === 'School') {
    if (selection['School District']) {
      return getObjectsMatchPropVal(groupData, 'district', selection['School District'])
    } else {
      return []
    }
  } else if (groupType === 'School District') {
    if (values(groupData).length > 0) {
      return values(groupData)
    } else {
      return []
    }
  }
}


// WEBPACK FOOTER //
// ./src/helpers/assessment/filterGroupData.js